module.exports = {
    direct: 'http://s3-yogabot-app.s3.eu-west-1.amazonaws.com/',
    carpetas: 'video_analysis/frames/',
    api: process.env.REACT_APP_VIDEO_ERRORS_API || 'http://localhost:4000/',
    securityApi:'https://security-dev.yogabot.app/security/admin/'
};